export default __webpack_public_path__ + "static/media/bootstrap.4f5aef35.webp";